export const ServicesData = [
  {
    id: 1,
    slug: "custom-software",
    title: "Custom Software Development",
    shortDescription: "Tailored software solutions built around your unique business needs, workflows, and long-term growth goals.",
    fullDescription:
      "We develop bespoke software solutions designed specifically for your business needs. Our custom software development service ensures that you get exactly what you need, nothing less.",
    icon: "💻",
    iconBg: "from-blue-500 to-cyan-500",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3",
    color: "blue",
    stats: [
      { label: "Projects Completed", value: "250+" },
      { label: "Client Satisfaction", value: "98%" },
      { label: "Avg. Time Savings", value: "40%" },
    ],
    features: [
      {
        title: "Requirement Analysis",
        description: "Deep dive into your business processes and requirements",
        icon: "🔍",
      },
      {
        title: "Custom Architecture",
        description: "Scalable and robust architecture designed for your needs",
        icon: "🏗️",
      },
      {
        title: "Agile Development",
        description: "Iterative development with continuous feedback",
        icon: "🔄",
      },
      {
        title: "Quality Assurance",
        description: "Comprehensive testing and quality checks",
        icon: "✅",
      },
      {
        title: "Integration",
        description: "Seamless integration with existing systems",
        icon: "🔌",
      },
      {
        title: "Maintenance",
        description: "Ongoing support and continuous improvement",
        icon: "⚙️",
      },
    ],
    benefits: [
      {
        title: "Competitive Advantage",
        description:
          "Stand out with unique solutions tailored to your business",
        icon: "🏆",
      },
      {
        title: "Scalability",
        description: "Grow without limits with scalable architecture",
        icon: "📈",
      },
      {
        title: "Cost Efficiency",
        description: "Optimize operations and reduce long-term costs",
        icon: "💰",
      },
      {
        title: "Full Ownership",
        description: "Complete control over your intellectual property",
        icon: "🔑",
      },
    ],
    technologies: [
      { name: "React", level: 95, icon: "⚛️" },
      { name: "Node.js", level: 90, icon: "🟢" },
      { name: "Python", level: 88, icon: "🐍" },
      { name: "Java", level: 85, icon: "☕" },
      { name: ".NET", level: 82, icon: "🔷" },
      { name: "MongoDB", level: 87, icon: "🍃" },
    ],
    process: [
      {
        step: 1,
        title: "Discovery",
        description: "Understanding your vision, goals, and requirements",
        duration: "1-2 weeks",
        icon: "🎯",
      },
      {
        step: 2,
        title: "Planning",
        description: "Architecture design, technology selection, and roadmap",
        duration: "2-3 weeks",
        icon: "📋",
      },
      {
        step: 3,
        title: "Development",
        description: "Agile sprints with regular demos and feedback",
        duration: "8-16 weeks",
        icon: "💻",
      },
      {
        step: 4,
        title: "Testing",
        description: "Comprehensive QA, performance testing, and optimization",
        duration: "2-4 weeks",
        icon: "🧪",
      },
      {
        step: 5,
        title: "Deployment",
        description: "Smooth launch with monitoring and support",
        duration: "1-2 weeks",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "Basic",
        price: "₹25,000",
        period: "starting at",
        features: [
          "Requirements Analysis",
          "MVP Development",
          "3 Months Support",
          "Basic Analytics",
        ],
        recommended: false,
      },
      {
        name: "Professional",
        price: "₹50,000",
        period: "starting at",
        features: [
          "Full Feature Set",
          "Advanced Security",
          "6 Months Support",
          "Performance Optimization",
          "Training",
        ],
        recommended: true,
      },
      {
        name: "Enterprise",
        price: "Custom",
        period: "tailored",
        features: [
          "Unlimited Features",
          "24/7 Support",
          "SLA Agreement",
          "Dedicated Team",
          "Custom Integrations",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "How long does custom software development take?",
        answer:
          "Timeline varies based on complexity, typically ranging from 3-6 months for a complete solution.",
      },
      {
        question: "Do you provide post-launch support?",
        answer:
          "Yes, we offer comprehensive maintenance and support packages tailored to your needs.",
      },
      {
        question: "Can you integrate with existing systems?",
        answer:
          "Absolutely! We specialize in seamless integration with your current tools and platforms.",
      },
    ],
    caseStudies: [
      {
        title: "FinTech Platform Transformation",
        client: "Global Finance Corp",
        result: "40% increase in processing speed",
        image:
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3",
      },
      {
        title: "Healthcare Management System",
        client: "MediCare Plus",
        result: "60% reduction in paperwork",
        image:
          "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3",
      },
    ],
  },
  {
    id: 2,
    slug: "ui-ux-design",
    title: "UI/UX Design",
    shortDescription: "Beautiful, intuitive interfaces designed to create engaging user experiences and make every interaction simple and seamless.",
    fullDescription:
      "Create stunning user experiences that your customers will love. Our UI/UX design service focuses on creating intuitive, accessible, and visually appealing interfaces.",
    icon: "🎨",
    iconBg: "from-purple-500 to-pink-500",
    image:
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3",
    color: "purple",
    stats: [
      { label: "Designs Delivered", value: "500+" },
      { label: "User Satisfaction", value: "96%" },
      { label: "Conversion Increase", value: "45%" },
    ],
    features: [
      {
        title: "User Research",
        description: "Deep understanding of user needs and behaviors",
        icon: "👥",
      },
      {
        title: "Wireframing",
        description: "Structural design and user flow mapping",
        icon: "📐",
      },
      {
        title: "Visual Design",
        description: "Stunning visuals that align with your brand",
        icon: "✨",
      },
      {
        title: "Interactive Prototypes",
        description: "Clickable prototypes for user testing",
        icon: "🎯",
      },
      {
        title: "Usability Testing",
        description: "Real user feedback and iteration",
        icon: "🧪",
      },
      {
        title: "Design Systems",
        description: "Consistent, scalable design components",
        icon: "📚",
      },
    ],
    benefits: [
      {
        title: "Higher Engagement",
        description: "Users stay longer and interact more",
        icon: "📊",
      },
      {
        title: "Brand Loyalty",
        description: "Memorable experiences build trust",
        icon: "❤️",
      },
      {
        title: "Faster Development",
        description: "Clear designs speed up development",
        icon: "⚡",
      },
      {
        title: "Higher Conversions",
        description: "Intuitive design leads to more sales",
        icon: "💰",
      },
    ],
    technologies: [
      { name: "Figma", level: 98, icon: "🎨" },
      { name: "Adobe XD", level: 92, icon: "🎯" },
      { name: "Sketch", level: 88, icon: "✏️" },
      { name: "InVision", level: 85, icon: "👁️" },
      { name: "Framer", level: 80, icon: "⚛️" },
      { name: "Principle", level: 75, icon: "🔄" },
    ],
    process: [
      {
        step: 1,
        title: "Discover",
        description: "User research, competitor analysis, and goal setting",
        duration: "1-2 weeks",
        icon: "🔍",
      },
      {
        step: 2,
        title: "Define",
        description:
          "User personas, journey maps, and information architecture",
        duration: "1-2 weeks",
        icon: "🎯",
      },
      {
        step: 3,
        title: "Design",
        description: "Wireframes, mockups, and interactive prototypes",
        duration: "3-4 weeks",
        icon: "✏️",
      },
      {
        step: 4,
        title: "Test",
        description: "Usability testing and design iteration",
        duration: "1-2 weeks",
        icon: "🧪",
      },
      {
        step: 5,
        title: "Deliver",
        description: "Design specifications and asset handoff",
        duration: "1 week",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "UX Audit",
        price: "₹5,000",
        period: "starting at",
        features: [
          "Heuristic Evaluation",
          "User Testing",
          "Recommendations Report",
          "Priority Support",
        ],
        recommended: false,
      },
      {
        name: "Full Design",
        price: "₹25,000",
        period: "starting at",
        features: [
          "User Research",
          "Wireframes & Prototypes",
          "Visual Design",
          "Design System",
          "Developer Handoff",
        ],
        recommended: true,
      },
      {
        name: "Ong Partnership",
        price: "₹8,000/mo",
        period: "monthly",
        features: [
          "Unlimited Requests",
          "Priority Queue",
          "Dedicated Designer",
          "Fast Turnaround",
          "Strategy Calls",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "How many design iterations are included?",
        answer:
          "Our process includes up to 3 rounds of revisions per design phase to ensure perfection.",
      },
      {
        question: "Do you conduct user testing?",
        answer:
          "Yes, we include comprehensive user testing with real users to validate designs.",
      },
      {
        question: "What files will I receive?",
        answer:
          "You'll get Figma files, design specifications, assets, and style guides.",
      },
    ],
    caseStudies: [
      {
        title: "E-commerce Redesign",
        client: "Fashion Retailer X",
        result: "65% increase in conversion rate",
        image:
          "https://images.unsplash.com/photo-1732258357001-e22ae4f65761?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      },
      {
        title: "Banking App UX",
        client: "NeoBank",
        result: "4.8★ app store rating",
        image:
          "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=688&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      },
    ],
  },
  {
    id: 3,
    slug: "crm-solutions",
    title: "CRM Solutions",
    shortDescription: "Manage customers smarter with powerful CRM solutions that streamline relationships, improve productivity, and drive business growth.",
    fullDescription:
      "Streamline your customer relationships with our comprehensive CRM solutions. We help you manage, analyze, and improve your customer interactions.",
    icon: "🤝",
    iconBg: "from-green-500 to-emerald-500",
    image:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3",
    color: "green",
    stats: [
      { label: "Sales Increase", value: "35%" },
      { label: "Retention Rate", value: "+25%" },
      { label: "Active Users", value: "10k+" },
    ],
    features: [
      {
        title: "Contact Management",
        description: "Centralized database with 360° customer view",
        icon: "📇",
      },
      {
        title: "Sales Pipeline",
        description: "Visual tracking from lead to closed deal",
        icon: "📊",
      },
      {
        title: "Automated Marketing",
        description: "Personalized campaigns and follow-ups",
        icon: "📧",
      },
      {
        title: "Analytics Dashboard",
        description: "Real-time insights and reports",
        icon: "📈",
      },
      {
        title: "Mobile Access",
        description: "Manage on-the-go with mobile apps",
        icon: "📱",
      },
      {
        title: "Integration Hub",
        description: "Connect with your favorite tools",
        icon: "🔗",
      },
    ],
    benefits: [
      {
        title: "Better Relationships",
        description: "Never miss a customer interaction",
        icon: "❤️",
      },
      {
        title: "Increased Sales",
        description: "Close more deals with better insights",
        icon: "💰",
      },
      {
        title: "Team Efficiency",
        description: "Automate repetitive tasks",
        icon: "⚡",
      },
      {
        title: "Data Security",
        description: "Enterprise-grade data protection",
        icon: "🔒",
      },
    ],
    technologies: [
      { name: "Salesforce", level: 95, icon: "☁️" },
      { name: "HubSpot", level: 92, icon: "🔄" },
      { name: "Zoho", level: 88, icon: "🌐" },
      { name: "Microsoft Dynamics", level: 85, icon: "🔷" },
      { name: "Custom Solutions", level: 90, icon: "⚙️" },
      { name: "Pipedrive", level: 82, icon: "📊" },
    ],
    process: [
      {
        step: 1,
        title: "Assessment",
        description: "Evaluate current processes and needs",
        duration: "1 week",
        icon: "📋",
      },
      {
        step: 2,
        title: "Selection",
        description: "Choose the right CRM platform",
        duration: "1-2 weeks",
        icon: "🎯",
      },
      {
        step: 3,
        title: "Migration",
        description: "Data migration and system setup",
        duration: "2-3 weeks",
        icon: "🔄",
      },
      {
        step: 4,
        title: "Integration",
        description: "Connect with existing tools",
        duration: "1-2 weeks",
        icon: "🔌",
      },
      {
        step: 5,
        title: "Training",
        description: "Team onboarding and adoption",
        duration: "1-2 weeks",
        icon: "📚",
      },
    ],
    pricing: [
      {
        name: "Starter",
        price: "₹5,000",
        period: "one-time setup",
        features: [
          "Basic Setup",
          "Data Migration",
          "3 Users Training",
          "Email Support",
        ],
        recommended: false,
      },
      {
        name: "Professional",
        price: "₹15,000",
        period: "setup + annual",
        features: [
          "Full Configuration",
          "Custom Fields",
          "Workflow Automation",
          "10 Users Training",
          "Phone Support",
        ],
        recommended: true,
      },
      {
        name: "Enterprise",
        price: "Custom",
        period: "tailored solution",
        features: [
          "Custom Development",
          "API Integration",
          "Unlimited Users",
          "Dedicated Support",
          "SLA Guarantee",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "How long does CRM implementation take?",
        answer: "Typically 4-8 weeks depending on complexity and data volume.",
      },
      {
        question: "Can you migrate data from our current system?",
        answer:
          "Yes, we handle complete data migration with validation and cleanup.",
      },
      {
        question: "Do you provide ongoing support?",
        answer:
          "Yes, we offer various support packages including 24/7 emergency support.",
      },
    ],
    caseStudies: [
      {
        title: "Real Estate CRM",
        client: "Premier Properties",
        result: "40% faster lead response",
        image:
          "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?ixlib=rb-4.0.3",
      },
      {
        title: "Healthcare CRM",
        client: "CarePlus Medical",
        result: "30% increase in patient retention",
        image:
          "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3",
      },
    ],
  },
  {
    id: 4,
    slug: "mobile-app-development",
    title: "Mobile App Development",
    shortDescription: "Build engaging iOS and Android experiences with fast, scalable, and user-friendly mobile applications tailored to your business needs.",
    fullDescription:
      "Build powerful mobile applications that engage users and drive business growth. We create native and cross-platform apps for iOS and Android.",
    icon: "📱",
    iconBg: "from-orange-500 to-red-500",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3",
    color: "orange",
    stats: [
      { label: "Apps Launched", value: "150+" },
      { label: "Downloads", value: "5M+" },
      { label: "Store Rating", value: "4.8★" },
    ],
    features: [
      {
        title: "Native iOS",
        description: "Swift/SwiftUI development for Apple devices",
        icon: "🍎",
      },
      {
        title: "Native Android",
        description: "Kotlin/Jetpack Compose for Android",
        icon: "🤖",
      },
      {
        title: "Cross-Platform",
        description: "Flutter/React Native for both platforms",
        icon: "🔄",
      },
      {
        title: "App Store Optimization",
        description: "Maximize visibility and downloads",
        icon: "📈",
      },
      {
        title: "Push Notifications",
        description: "Engage users with timely updates",
        icon: "🔔",
      },
      {
        title: "Analytics Integration",
        description: "Track user behavior and app performance",
        icon: "📊",
      },
    ],
    benefits: [
      {
        title: "Wider Reach",
        description: "Connect with users on any device",
        icon: "🌍",
      },
      {
        title: "Better Engagement",
        description: "Push notifications and mobile features",
        icon: "📱",
      },
      {
        title: "Offline Access",
        description: "Work without internet connection",
        icon: "📴",
      },
      {
        title: "Monetization",
        description: "Multiple revenue streams",
        icon: "💰",
      },
    ],
    technologies: [
      { name: "Swift", level: 94, icon: "🍎" },
      { name: "Kotlin", level: 92, icon: "🤖" },
      { name: "Flutter", level: 90, icon: "🦋" },
      { name: "React Native", level: 88, icon: "⚛️" },
      { name: "Firebase", level: 91, icon: "🔥" },
      { name: "iOS/Android SDK", level: 89, icon: "📱" },
    ],
    process: [
      {
        step: 1,
        title: "Discovery",
        description: "Platform selection and feature definition",
        duration: "1-2 weeks",
        icon: "🎯",
      },
      {
        step: 2,
        title: "Design",
        description: "Mobile-optimized UI/UX design",
        duration: "2-3 weeks",
        icon: "🎨",
      },
      {
        step: 3,
        title: "Development",
        description: "Agile sprints with regular builds",
        duration: "8-12 weeks",
        icon: "💻",
      },
      {
        step: 4,
        title: "Testing",
        description: "Device compatibility and performance",
        duration: "2-3 weeks",
        icon: "🧪",
      },
      {
        step: 5,
        title: "Deployment",
        description: "App store submission and launch",
        duration: "1-2 weeks",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "MVP",
        price: "₹30,000",
        period: "starting at",
        features: [
          "Core Features",
          "Single Platform",
          "Basic UI",
          "App Store Submission",
        ],
        recommended: false,
      },
      {
        name: "Full App",
        price: "₹60,000",
        period: "starting at",
        features: [
          "All Features",
          "Both Platforms",
          "Custom Design",
          "Analytics",
          "Push Notifications",
        ],
        recommended: true,
      },
      {
        name: "Enterprise",
        price: "Custom",
        period: "complex apps",
        features: [
          "Advanced Features",
          "Backend Integration",
          "Scalable Architecture",
          "24/7 Support",
          "SLA",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "Which platform should we start with?",
        answer:
          "We recommend starting with one platform based on your target audience and budget.",
      },
      {
        question: "How long does app store approval take?",
        answer: "Typically 1-2 weeks for Apple and 1-3 days for Google Play.",
      },
      {
        question: "Do you provide maintenance after launch?",
        answer: "Yes, we offer ongoing maintenance and update packages.",
      },
    ],
    caseStudies: [
      {
        title: "Food Delivery App",
        client: "QuickEats",
        result: "100k+ downloads in first month",
        image:
          "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?ixlib=rb-4.0.3",
      },
      {
        title: "Fitness Tracking App",
        client: "FitLife",
        result: "4.9★ rating with 50k users",
        image:
          "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?ixlib=rb-4.0.3",
      },
    ],
  },
  {
    id: 5,
    slug: "mlm-software",
    title: "MLM Software",
    shortDescription: "Powerful multi-level network platforms designed to simplify management, automate operations, and support scalable business growth.",
    fullDescription:
      "Comprehensive MLM software solutions for network marketing businesses. Manage your downline, commissions, and growth effectively.",
    icon: "🌐",
    iconBg: "from-indigo-500 to-purple-500",
    image:
      "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3",
    color: "indigo",
    stats: [
      { label: "Active Networks", value: "500+" },
      { label: "Commission Accuracy", value: "99.9%" },
      { label: "Countries Served", value: "30+" },
    ],
    features: [
      {
        title: "Genealogy Tree",
        description: "Visual representation of your network",
        icon: "🌳",
      },
      {
        title: "Commission Engine",
        description: "Automated calculation for all plan types",
        icon: "💰",
      },
      {
        title: "Payment Processing",
        description: "Secure and timely commission payouts",
        icon: "💳",
      },
      {
        title: "Member Dashboard",
        description: "Self-service portal for distributors",
        icon: "👥",
      },
      {
        title: "E-Pin System",
        description: "Secure product and membership activation",
        icon: "🔑",
      },
      {
        title: "Reports & Analytics",
        description: "Real-time business intelligence",
        icon: "📊",
      },
    ],
    benefits: [
      {
        title: "Automated Calculations",
        description: "Error-free commission processing",
        icon: "🤖",
      },
      {
        title: "Scalable Growth",
        description: "Handle unlimited members and transactions",
        icon: "📈",
      },
      {
        title: "Regulatory Compliance",
        description: "Stay compliant with MLM regulations",
        icon: "⚖️",
      },
      {
        title: "Real-time Tracking",
        description: "Monitor network growth instantly",
        icon: "⏱️",
      },
    ],
    technologies: [
      { name: "PHP", level: 92, icon: "🐘" },
      { name: "MySQL", level: 94, icon: "🗄️" },
      { name: "Node.js", level: 88, icon: "🟢" },
      { name: "MongoDB", level: 85, icon: "🍃" },
      { name: "React", level: 87, icon: "⚛️" },
      { name: "Blockchain", level: 75, icon: "⛓️" },
    ],
    process: [
      {
        step: 1,
        title: "Plan Analysis",
        description: "Understanding your compensation plan",
        duration: "1 week",
        icon: "📋",
      },
      {
        step: 2,
        title: "System Design",
        description: "Architecture for your specific needs",
        duration: "2 weeks",
        icon: "🏗️",
      },
      {
        step: 3,
        title: "Development",
        description: "Building core MLM functionality",
        duration: "6-8 weeks",
        icon: "💻",
      },
      {
        step: 4,
        title: "Testing",
        description: "Commission accuracy and load testing",
        duration: "2 weeks",
        icon: "🧪",
      },
      {
        step: 5,
        title: "Deployment",
        description: "Launch and team training",
        duration: "1 week",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "Starter",
        price: "₹15,000",
        period: "one-time",
        features: [
          "Binary/Unilevel Plans",
          "Up to 1000 Members",
          "Basic Reports",
          "Email Support",
        ],
        recommended: false,
      },
      {
        name: "Professional",
        price: "₹35,000",
        period: "one-time",
        features: [
          "All Plan Types",
          "Unlimited Members",
          "Advanced Reports",
          "API Access",
          "Priority Support",
        ],
        recommended: true,
      },
      {
        name: "Enterprise",
        price: "₹60,000+",
        period: "custom",
        features: [
          "Custom Plans",
          "Blockchain Integration",
          "Global Payments",
          "Dedicated Team",
          "SLA",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "Which compensation plans do you support?",
        answer:
          "We support all major plans: Binary, Unilevel, Matrix, Board, and Hybrid plans.",
      },
      {
        question: "How do you handle international payments?",
        answer:
          "We integrate with multiple payment gateways supporting 100+ currencies.",
      },
      {
        question: "Is the software scalable for global growth?",
        answer:
          "Yes, our architecture supports unlimited users and transactions globally.",
      },
    ],
    caseStudies: [
      {
        title: "Wellness Products MLM",
        client: "HealthyLife Global",
        result: "10,000+ distributors in 6 months",
        image:
          "https://images.unsplash.com/photo-1543352634-99a5d50ae78e?ixlib=rb-4.0.3",
      },
      {
        title: "Financial Services Network",
        client: "WealthBuilders",
        result: "₹5M+ monthly commission processing",
        image:
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3",
      },
    ],
  },
  {
    id: 6,
    slug: "web-development",
    title: "Web Development",
    shortDescription: "Fast, modern, and responsive web applications built to deliver seamless user experiences, strong performance, and scalable business growth.",
    fullDescription:
      "Create powerful web applications that drive your business forward. We build responsive, high-performance websites and web apps.",
    icon: "🌍",
    iconBg: "from-teal-500 to-cyan-500",
    image:
      "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3",
    color: "teal",
    stats: [
      { label: "Websites Launched", value: "300+" },
      { label: "Load Time", value: "<1.5s" },
      { label: "Uptime SLA", value: "99.99%" },
    ],
    features: [
      {
        title: "Responsive Design",
        description: "Perfect on all devices and screen sizes",
        icon: "📱",
      },
      {
        title: "Performance Optimized",
        description: "Lightning-fast load times",
        icon: "⚡",
      },
      {
        title: "SEO Friendly",
        description: "Built with search engines in mind",
        icon: "🔍",
      },
      {
        title: "E-commerce Solutions",
        description: "Full-featured online stores",
        icon: "🛒",
      },
      {
        title: "CMS Integration",
        description: "Easy content management",
        icon: "📝",
      },
      {
        title: "API Development",
        description: "Robust backend services",
        icon: "🔌",
      },
    ],
    benefits: [
      {
        title: "24/7 Availability",
        description: "Your business never sleeps",
        icon: "🌙",
      },
      {
        title: "Global Reach",
        description: "Connect with customers worldwide",
        icon: "🌍",
      },
      {
        title: "Cost Effective",
        description: "Lower overhead than physical stores",
        icon: "💰",
      },
      {
        title: "Easy Updates",
        description: "Quick content and feature updates",
        icon: "🔄",
      },
    ],
    technologies: [
      { name: "React", level: 95, icon: "⚛️" },
      { name: "Next.js", level: 92, icon: "▲" },
      { name: "Node.js", level: 90, icon: "🟢" },
      { name: "TypeScript", level: 88, icon: "📘" },
      { name: "Tailwind CSS", level: 94, icon: "🎨" },
      { name: "GraphQL", level: 85, icon: "◉" },
    ],
    process: [
      {
        step: 1,
        title: "Requirements",
        description: "Defining scope and functionality",
        duration: "1-2 weeks",
        icon: "📋",
      },
      {
        step: 2,
        title: "Design",
        description: "UI/UX and visual design",
        duration: "2-3 weeks",
        icon: "🎨",
      },
      {
        step: 3,
        title: "Development",
        description: "Frontend and backend coding",
        duration: "6-8 weeks",
        icon: "💻",
      },
      {
        step: 4,
        title: "Testing",
        description: "Cross-browser and performance testing",
        duration: "1-2 weeks",
        icon: "🧪",
      },
      {
        step: 5,
        title: "Launch",
        description: "Deployment and optimization",
        duration: "1 week",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "Basic Website",
        price: "₹8,000",
        period: "starting at",
        features: [
          "5 Pages",
          "Responsive Design",
          "Basic SEO",
          "Contact Form",
          "1 Month Support",
        ],
        recommended: false,
      },
      {
        name: "Business Website",
        price: "₹15,000",
        period: "starting at",
        features: [
          "10-15 Pages",
          "CMS Integration",
          "Advanced SEO",
          "Blog Setup",
          "3 Months Support",
        ],
        recommended: true,
      },
      {
        name: "Web Application",
        price: "₹30,000",
        period: "starting at",
        features: [
          "Custom Functionality",
          "User Authentication",
          "Database Integration",
          "API Development",
          "6 Months Support",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "How long does it take to build a website?",
        answer: "Simple sites take 4-6 weeks, complex applications 3-6 months.",
      },
      {
        question: "Do you provide hosting?",
        answer: "Yes, we offer managed hosting with 99.99% uptime guarantee.",
      },
      {
        question: "Can I update content myself?",
        answer:
          "Absolutely! We provide easy-to-use CMS for content management.",
      },
    ],
    caseStudies: [
      {
        title: "E-commerce Platform",
        client: "FashionHub",
        result: "200% increase in online sales",
        image:
          "https://images.unsplash.com/photo-1555529669-2269763671c0?ixlib=rb-4.0.3",
      },
      {
        title: "Real Estate Portal",
        client: "PropertyFinder",
        result: "50k+ monthly active users",
        image:
          "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3",
      },
    ],
  },
  {
    id: 7,
    slug: "ai-ml-solutions",
    title: "AI & ML Solutions",
    shortDescription: "Intelligent automation and data-driven insights that help businesses streamline processes, improve decisions, and unlock new growth opportunities.",
    fullDescription:
      "Harness the power of artificial intelligence and machine learning to automate processes, uncover hidden insights, and build predictive models that give your business a decisive edge.",
    icon: "🤖",
    iconBg: "from-violet-500 to-fuchsia-500",
    image:
      "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?ixlib=rb-4.0.3",
    color: "violet",
    stats: [
      { label: "AI Models Deployed", value: "80+" },
      { label: "Accuracy Achieved", value: "97.5%" },
      { label: "Process Automation", value: "70%" },
    ],
    features: [
      {
        title: "Predictive Analytics",
        description: "Forecast trends and customer behavior with ML models",
        icon: "🔮",
      },
      {
        title: "Natural Language Processing",
        description: "Chatbots, sentiment analysis, and text classification",
        icon: "💬",
      },
      {
        title: "Computer Vision",
        description: "Image recognition, object detection, and OCR",
        icon: "👁️",
      },
      {
        title: "Recommendation Engines",
        description: "Personalized product and content recommendations",
        icon: "🎯",
      },
      {
        title: "Anomaly Detection",
        description: "Real-time fraud and outlier detection",
        icon: "🚨",
      },
      {
        title: "AI Integration",
        description: "Embed AI capabilities into your existing apps",
        icon: "🔌",
      },
    ],
    benefits: [
      {
        title: "Smarter Decisions",
        description: "Data-driven insights replace guesswork",
        icon: "🧠",
      },
      {
        title: "Cost Automation",
        description: "Reduce manual effort by up to 70%",
        icon: "⚙️",
      },
      {
        title: "Faster Processing",
        description: "Handle millions of data points in milliseconds",
        icon: "⚡",
      },
      {
        title: "Competitive Edge",
        description: "AI-powered products outperform competitors",
        icon: "🏆",
      },
    ],
    technologies: [
      { name: "Python / PyTorch", level: 96, icon: "🐍" },
      { name: "TensorFlow", level: 93, icon: "🔬" },
      { name: "OpenAI API", level: 92, icon: "🤖" },
      { name: "Hugging Face", level: 89, icon: "🤗" },
      { name: "Scikit-learn", level: 94, icon: "📊" },
      { name: "Apache Spark", level: 85, icon: "⚡" },
    ],
    process: [
      {
        step: 1,
        title: "Problem Framing",
        description: "Define the AI use case and success metrics",
        duration: "1 week",
        icon: "🎯",
      },
      {
        step: 2,
        title: "Data Collection",
        description: "Gather, clean, and label training data",
        duration: "2-4 weeks",
        icon: "🗄️",
      },
      {
        step: 3,
        title: "Model Development",
        description: "Train, validate, and iterate on ML models",
        duration: "4-8 weeks",
        icon: "🔬",
      },
      {
        step: 4,
        title: "Evaluation",
        description: "Accuracy, bias, and performance benchmarking",
        duration: "1-2 weeks",
        icon: "📏",
      },
      {
        step: 5,
        title: "Deployment",
        description: "Production integration with monitoring",
        duration: "1-2 weeks",
        icon: "🚀",
      },
    ],
    pricing: [
      {
        name: "AI Proof of Concept",
        price: "₹15,000",
        period: "one-time",
        features: [
          "Single Use Case",
          "Data Pipeline",
          "Model Training",
          "Demo Dashboard",
        ],
        recommended: false,
      },
      {
        name: "Production AI",
        price: "₹45,000",
        period: "starting at",
        features: [
          "Full ML Pipeline",
          "API Endpoint",
          "Model Monitoring",
          "Retraining Schedule",
          "6-Month Support",
        ],
        recommended: true,
      },
      {
        name: "AI Partnership",
        price: "₹10,000/mo",
        period: "monthly retainer",
        features: [
          "Dedicated ML Engineers",
          "Multiple Models",
          "Continuous Improvement",
          "Data Strategy",
          "Priority Support",
        ],
        recommended: false,
      },
    ],
    faqs: [
      {
        question: "Do we need large amounts of data to start?",
        answer:
          "Not always. We can use transfer learning and synthetic data generation to work effectively with smaller datasets.",
      },
      {
        question: "How do you ensure AI model fairness?",
        answer:
          "We apply bias detection and fairness audits throughout the model lifecycle as standard practice.",
      },
      {
        question: "Can AI integrate with our existing software?",
        answer:
          "Yes, we expose models via REST APIs or SDKs that integrate seamlessly with any tech stack.",
      },
    ],
    caseStudies: [
      {
        title: "Fraud Detection Engine",
        client: "SecurePay",
        result: "94% fraud detection accuracy",
        image:
          "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?ixlib=rb-4.0.3",
      },
      {
        title: "AI Demand Forecasting",
        client: "RetailChain Co.",
        result: "32% reduction in overstock costs",
        image:
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3",
      },
    ],
  },
];
